//logo
const MAIN_LOGO = require("./main_logo.png");
const ICON_PREV_ALL = require("./icon_prev_all.png");
const ICON_PREV = require("./icon_prev.png");
const ICON_NEXT = require("./icon_next.png");
const ICON_NEXT_ALL = require("./icon_next_all.png");

export { MAIN_LOGO, ICON_PREV_ALL, ICON_PREV, ICON_NEXT, ICON_NEXT_ALL };
